export const defaultColors = {
  bg_primary_color: "#ffffff",
  bg_secondary_color: "#ffffff",
  bg_tertiary_color: "#ffffff",
  text_color_heading: "#000000",
  text_color_subheading: "#000000",
  text_color_paragraph: "#000000",
};
